import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, of } from 'rxjs';
import { AppConstants } from '../../../config/app-constants';
import { LoaderService } from './loading.service';

@Injectable({
    providedIn: 'root'
})
export class RolesService {
    private apiUrl = AppConstants.APP_BASE_API_URL;
    constructor(private http: HttpClient, private loaderService: LoaderService) { }
    public permissionData = new Subject<any>();

    setPermissionData(data: any) {
        this.permissionData.next(data);
    }

    getUserRoles(payload) {
        this.loaderService.hideLoader();
        return this.http.get(`${AppConstants.APP_BASE_API_URL}authorization`, { params: payload });
    }
    getUserRoles1(payload): Observable<any> {
        this.loaderService.hideLoader();
        return this.http.post(`${AppConstants.APP_BASE_API_URL}authorization`, payload);
    }
    getScreenAccess(screen: any) {
        let isScreenAccessible = false;
        let userDetails = JSON.parse(this.loaderService.getItem('userDetails'));
        if (userDetails) {
            userDetails.userAllowedScreenList.forEach((element: string) => {
                if (element.toLowerCase() == screen.toLowerCase()) {
                    isScreenAccessible = true;
                }
            });
        }
        return isScreenAccessible;
    }

    getFeatureAccess(featureList: any[]) {
        const userDetails = this.loaderService.getItem('userDetails');
        if (!userDetails) {
            return of(false);
        } else {
            const privileges = JSON.parse(userDetails).privilegeInfo.privileges;
            return of(
                privileges.some(
                    (privilege) => featureList.includes(privilege.functionName) && privilege.privilegeType === 'UPDATE'
                )
            );
        }
    }

    getElementAccess(selectedElement: any) {
        let isElementAccessible = false;
        let userDetails = this.loaderService.getItem('userDetails')
            ? JSON.parse(this.loaderService.getItem('userDetails'))
            : null;
        if (userDetails) {
            const selectedRole = userDetails.privilegeInfo.privileges.filter(
                (element) => element.functionName.toLowerCase() == selectedElement.replace(/'/g, '').toLowerCase()
            );
            if (selectedRole && selectedRole.length > 0) {
                const selectedRoleUpdate = selectedRole.filter((element) => element.privilegeType === 'UPDATE');
                if (selectedRoleUpdate && selectedRoleUpdate.length > 0) {
                    isElementAccessible = true;
                }
            }
        }

        return isElementAccessible;
    }
}